import { hrefFor } from '@omnea-app/fe-authz/routeHref'

/** Settings, remembering the page it was opened from so "Back to app" returns there. */
export const settingsHrefFrom = (asPath: string) => `${hrefFor('settingsNotifications')}?from=${encodeURIComponent(asPath)}`
